import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import ActionDelete from '@material-ui/icons/Delete';
import classnames from 'classnames';
import { translate, crudDelete, startUndoable } from 'ra-core';
import IconCancel from '@material-ui/icons/Cancel';
import IconConfirm from '@material-ui/icons/ConfirmationNumberRounded';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'react-admin';
import decodeJwt from 'jwt-decode';
const config = require('../../config.json');

const styles = (theme) => ({
  deleteButton: {
    color: theme.palette.error.main,
    '&:hover': {
      backgroundColor: fade(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }
});

class DeletePermButtonWithConfirmation extends Component {
  state = {
    showDialog: false,
    showDialog2: false,
    showDialog3: false,
    token: decodeJwt(localStorage.getItem("token")).access_token
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleClick2 = () => {
    this.setState({ showDialog2: true });
  };

  backButton = () => {
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host
    window.location = baseUrl + "/#/users?filter={}";
  } 

  handleClick3 = () => {
    this.setState({ showDialog3: true });
  };

  handleCloseClick3 = () => {
    this.setState({ showDialog3: false });
  };

  handleCloseClick2 = () => {
    this.setState({ showDialog2: false });
    this.backButton();
  };

  
  handleDelete = async (event) => {
    event.preventDefault();
    this.setState({ showDialog: false });
    const { record } = this.props;
    await fetch(config.API_URL + "/users/" + record.username + "/permdelete", {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': this.state.token
      },
    })
    .then(res => {
      return res.json();
    })
    .then(data => {
      console.log(data);
      if (data && data.data.username === record.username) {
        this.setState({ showDialog2: true });
      } else {
        this.setState({ showDialog3: true });
      }
    })
    .catch(err => {
      console.log(err);
      this.setState({ showDialog3: true });
    })
  };

  render() {
    const { showDialog, showDialog2, showDialog3 } = this.state;
    const { label = 'ra.action.delete', classes = {}, className } = this.props;
    return (
      <Fragment>
        <Button onClick={this.handleClick} label={label} className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
          <ActionDelete />
        </Button>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick} aria-label="Are you sure?">
          <DialogTitle>{"¿Deseas eliminar permanentemente al usuario?"}</DialogTitle>
          <DialogContent>
            <div>
              <p>El usuario se eliminará completamente de la aplicación.</p>
              <p>En caso de tener transacciones NO se realizará esta acción.</p>
              <p>Su correo electrónico y nombre de usuario SI quedará disponible para otras personas.</p>
              <p>Tus acciones serán guardadas. IR A LISTA DE USUARIOS para ver cambios.</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDelete} label={label} className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
              <ActionDelete />
            </Button>
            <Button label="Cancelar" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth open={showDialog2} onClose={this.handleCloseClick2} aria-label="Are you sure?">
          <DialogTitle>{"Eliminación permanente"}</DialogTitle>
          <DialogContent>
            <div>
              <p>Se ha eliminado correctamente al usuario.</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button label="Confirmar" onClick={this.handleCloseClick2}>
              <IconConfirm />
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth open={showDialog3} onClose={this.handleCloseClick3} aria-label="Are you sure?">
          <DialogTitle>{"Error de eliminación"}</DialogTitle>
          <DialogContent>
            <div>
              <p>Usuario no puede ser eliminado.</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button label="Confirmar" onClick={this.handleCloseClick3}>
              <IconConfirm />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DeletePermButtonWithConfirmation.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  undoable: PropTypes.bool
};

DeletePermButtonWithConfirmation.defaultProps = {
  redirect: 'list',
  undoable: true
};

export default compose(
  connect(
    null,
    { startUndoable, dispatchCrudDelete: crudDelete }
  ),
  translate,
  withStyles(styles)
)(DeletePermButtonWithConfirmation);